import { c as _c } from "react/compiler-runtime";
import { isAmexOffer } from '@cc-shopping/utils/offers';
import ApprovalOdds from 'src/features/approval-odds';
import { useCreditCardCompareColumnContext } from '../../ColumnContext';
import { useCreditCardCompareOfferContext } from '../../OfferContext';
export function CommonApprovalOdds(t0) {
  const $ = _c(13);
  const {
    smallApprovalLabelText: t1
  } = t0;
  const smallApprovalLabelText = t1 === undefined ? false : t1;
  const {
    index
  } = useCreditCardCompareColumnContext();
  const {
    offer: t2
  } = useCreditCardCompareOfferContext();
  const {
    minFico,
    maxFico,
    limitedCreditHistory,
    institution
  } = t2;
  let t3;
  if ($[0] !== institution) {
    t3 = isAmexOffer({
      institution
    });
    $[0] = institution;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const isAmexCard = t3;
  let t4;
  if ($[2] !== maxFico || $[3] !== minFico) {
    t4 = {
      min: minFico,
      max: maxFico
    };
    $[2] = maxFico;
    $[3] = minFico;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== index) {
    t5 = {
      sectionName: "cc_compare_grid",
      elementPosition: index
    };
    $[5] = index;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isAmexCard || $[8] !== limitedCreditHistory || $[9] !== smallApprovalLabelText || $[10] !== t4 || $[11] !== t5) {
    t6 = <ApprovalOdds odds={t4} hasLimitedCreditHistory={limitedCreditHistory} graphContent={true} firePageActionOnClick={true} isAmexOffer={isAmexCard} smallApprovalLabelText={smallApprovalLabelText} analytics={t5} />;
    $[7] = isAmexCard;
    $[8] = limitedCreditHistory;
    $[9] = smallApprovalLabelText;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}